
var isPageRefreshRequired: boolean;
//const nameof = <T>(name: keyof T) => name;
//const nameofFactory = <T>() => (name: keyof T) => name;
//usage const nameof = nameofFactory<Edoc.RevenueReportModel>();

namespace q {
    export var queryString = {};
    export var jsPDFHeaderImageData: string = null
    export var jsPDFHeaderTitle: string = 'Report Title';
    export var useSerenityInlineEditors: boolean = false;

    export var DefaultMainGridOptions: ExtGridOptions = {
        AutoColumnSize: true,
        FadeInEffectWhenInit: true,
        ShowAnyInEqualityFilterWithTextValue: true,
        ShowInlineActionsColumn: false,
        ShowDeleteInlineButtun: false,
        ShowEditInlineButtun: true,
        ShowPrintInlineButtun: false,
        ShowRowNumberColumn: true,
        ShowRowSelectionCheckboxColumn: false,
        EnableQuickSearch: true,
        RowsPerPage: 50
    };

    export var DefaultEditorGridOptions: ExtGridOptions = {
        AutoColumnSize: true,
        FadeInEffectWhenInit: true,
        ShowAnyInEqualityFilterWithTextValue: true,
        ShowInlineActionsColumn: false,
        ShowDeleteInlineButtun: false,
        ShowEditInlineButtun: false,
        ShowPrintInlineButtun: false,
        ShowRowSelectionCheckboxColumn: false,
        ShowRowNumberColumn: false,
        EnableQuickSearch: false
    };

    export var DefaultEntityDialogOptions: ExtDialogOptions = {
        AutoFitContentArea: true,
        HideCategoyLinksBar: true,
        PendingChangesConfirmation: true,
        ShowSaveAndNewButtonInToolbar: true,
        ShowCloseButtonInToolbar: false,
        ShowRefreshButtonInToolbar: false,
        ShowChangeLogButtonInToolbar: true,
        ShowReplaceRowButtonInToolbar: false,
        ShowNextPreviousButton: true,
        ShowDeleteButton: true,
        ShowApplyButton: true,
        SetDialogHeight: 500,
        SetDialogWidth: 1000
    };
     
    export var DefaultEditorDialogOptions: ExtDialogOptions = {
        AutoFitContentArea: true,
        HideCategoyLinksBar: true,
        PendingChangesConfirmation: false,
        ShowSaveAndNewButtonInToolbar: true, 
        ShowCloseButtonInToolbar: false,
        ShowRefreshButtonInToolbar: false,
        ShowChangeLogButtonInToolbar: false,
        ShowReplaceRowButtonInToolbar: false,
        ShowNextPreviousButton: true,
        ShowDeleteButton: true,
        ShowApplyButton: true,
        SetDialogHeight: 500,
        SetDialogWidth: 1000
    };

    export var DefualtEditorOptions: ExtGridEditorOptions = {
        height: 200
    }

    //date time
    export var fiscalYearMonths = [6, 7, 8, 9, 10, 11, 0, 1, 2, 3, 4, 5]


    export class SalesItemsBom implements TabAurous.Sales.SalesItemsBOMRow {

        constructor(
            //public ProductId: number,
            //public ProductCode: string,
            //public BOMProductId: number,
            //public BOMAttributeId: number,
            //public BomRate: number,
            //public BomAmount: number,
            //public Remarks: string,
            //public CalcOnId: number,
            //public CalcOn: string,
            //public Pieces: number,
            //public Weight: number,
            //public ItemType: string,
            //public ItemTypeId: number,
            //public StoneColorId: number,
            //public Attribute: string,
            //public CertificateNo: string,
            //public CategoryId: number,
            //public SubCategoryId: number,
            //public ProductTypeId: number,
            //public QualityId: number,
            //public SieveId: number,
            //public ShapeId: number,
            //public StoneSizeId: number,
            //public SettingId: number,
            //public GroupSieveId: number,
            //public StoneCuletId: number,
            //public StoneCutId: number,
            //public StoneFluorescenceId: number,
            //public StoneGirdleId: number,
            //public StonePolishId: number,
            //public StoneSymmetryId: number,
            //public StoneDepth: string,
            //public StoneTable: string,
            //public Lab: string,
            //public RefTransBomId: number,
            //public CCBomAmount: number,
            //public IsCustomerItem: boolean,
            //public CostMethodId: number

        ) {}
    }


}
